import { render, staticRenderFns } from "./skuInfoManagement.vue?vue&type=template&id=8a308cf8&scoped=true"
import script from "./skuInfoManagement.vue?vue&type=script&lang=js"
export * from "./skuInfoManagement.vue?vue&type=script&lang=js"
import style0 from "./skuInfoManagement.vue?vue&type=style&index=0&id=8a308cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a308cf8",
  null
  
)

export default component.exports